import React from 'react';

import CreateUsers from './CreateKlass';

const Users: React.FC = () => {
  return <CreateUsers />;
};

export default Users;
